module.exports = JSON.parse('{"Primary":"أولي","Recent":"حديث","All":"الكل"}')